import {
    SilDevice,
    SilProjectDevice,
    SilDeviceNested,
    SilProjectDeviceNested,
} from "server/models"
import {
    SilType,
    PublishedUnpublished,
    OrderType,
    ProvenType,
} from "client/utils"

export type SilDeviceType = SilDevice | SilProjectDevice
export type SilDeviceNestedType = SilDeviceNested | SilProjectDeviceNested

export interface SilDeviceProps {
    deviceId?: number
}
export interface SilSubsystemProps {
    subsystemId?: number
}

export interface SilDeviceList { [deviceId: number]: SilDeviceType }
export interface SilDeviceFilters {
    name?: string
    manufacturer?: string
    type?: SilType
    lowDemandMode?: boolean
    highDemandMode?: boolean
    continuousMode?: boolean
    logicSolver?: boolean
    provenInUse?: ProvenType
    status?: PublishedUnpublished
    search?: string
}

export type SilDeviceValidation = { [key in keyof SilDeviceType]?: string }

export interface SilDeviceState {
    baseDeviceRoute: string
    baseSubsystemRoute: string

    deviceList: SilDeviceList
    deviceIds: readonly number[]
    deviceView: SilDeviceType
    deviceEdit: SilDeviceType

    nested: {
        currentDeviceList: readonly SilDeviceNestedType[]
        newDeviceList: readonly SilDeviceNestedType[]
    }

    sortColumn: keyof SilDeviceType
    sortOrder: OrderType
    filters: SilDeviceFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const SIL_DEVICE_BASE_ROUTE = "SIL_DEVICE_BASE_ROUTE"

export const SIL_DEVICE_LIST = "SIL_DEVICE_LIST"
export const SIL_DEVICE_IDS = "SIL_DEVICE_IDS"
export const SIL_DEVICE_VIEW = "SIL_DEVICE_VIEW"
export const SIL_DEVICE_EDIT = "SIL_DEVICE_EDIT"

export const SIL_DEVICE_NESTED_CURRENT_LIST = "SIL_DEVICE_NESTED_CURRENT_LIST"
export const SIL_DEVICE_NESTED_NEW_LIST = "SIL_DEVICE_NESTED_NEW_LIST"

export const SIL_DEVICE_SORT = "SIL_DEVICE_SORT"
export const SIL_DEVICE_FILTERS = "SIL_DEVICE_FILTERS"

export const SIL_DEVICE_RELOAD_LIST = "SIL_DEVICE_RELOAD_LIST"
export const SIL_DEVICE_RELOAD_VIEW = "SIL_DEVICE_RELOAD_VIEW"
export const SIL_DEVICE_RELOAD_EDIT = "SIL_DEVICE_RELOAD_EDIT"
